// ABOUTME: Small close/X icon for badges and small UI elements
// ABOUTME: Supports className, size, and color customization

interface SmallCloseIconProps {
  className?: string
  size?: number
  color?: string
}

export const SmallCloseIcon = ({ className = "", size = 14, color = "currentColor" }: SmallCloseIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
    />
  </svg>
)
